import type {TicketStatus, TicketChannel} from '../../tickets/types/ticket';
import {PRIORITY_LABELS, PRIORITY_ORDER} from '../../tickets/constants/priority';
import {CHANNEL_LABELS} from '../../tickets/constants/channels';
import type {FilterOptionItem} from '../../tickets/hooks/useFilterOptions';

export const DASHBOARD_STATUS_OPTIONS: FilterOptionItem[] = (
	['open', 'in_progress', 'waiting_on_customer', 'resolved', 'closed'] as TicketStatus[]
).map(id => {
	const label: Record<TicketStatus, string> = {
		open: 'Open',
		in_progress: 'In progress',
		waiting_on_customer: 'Waiting on customer',
		resolved: 'Resolved',
		closed: 'Closed',
	};
	return {id, label: label[id]};
});

export const DASHBOARD_PRIORITY_OPTIONS: FilterOptionItem[] = PRIORITY_ORDER.map(id => ({
	id,
	label: PRIORITY_LABELS[id],
}));

export const DASHBOARD_CHANNEL_OPTIONS: FilterOptionItem[] = (Object.keys(CHANNEL_LABELS) as TicketChannel[]).map(id => ({
	id,
	label: CHANNEL_LABELS[id],
}));

export const DASHBOARD_SLA_STATE_OPTIONS: FilterOptionItem[] = [
	{id: 'breached', label: 'Breached'},
	{id: 'paused', label: 'Paused'},
];
